import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=126d9b1c"
import script from "@/scripts/settings/settings.js?vue&type=script&lang=js&external"
export * from "@/scripts/settings/settings.js?vue&type=script&lang=js&external"
import style0 from "./Settings.vue?vue&type=style&index=0&id=126d9b1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports